/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ErrorResponse from '../model/ErrorResponse';
import UserNotificationPreferences from '../model/UserNotificationPreferences';
import UserNotificationPreferencesPatch from '../model/UserNotificationPreferencesPatch';

/**
* Notifications service.
* @module api/NotificationsApi
* @version 1.1.0
*/
export default class NotificationsApi {

    /**
    * Constructs a new NotificationsApi. 
    * @alias module:api/NotificationsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getUserNotificationPreferences operation.
     * @callback module:api/NotificationsApi~getUserNotificationPreferencesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserNotificationPreferences} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all notification preferences for a user
     * Returns all notification preferences for the user. Returns 404 if the user does not exist. Returns 200 with an empty preferences array if the user exists but has no preferences saved. 
     * @param {String} userId The unique identifier of the user
     * @param {module:api/NotificationsApi~getUserNotificationPreferencesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserNotificationPreferences}
     */
    getUserNotificationPreferences(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getUserNotificationPreferences");
      }

      let pathParams = {
        'userId': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UserNotificationPreferences;
      return this.apiClient.callApi(
        '/users/notifications/{userId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setUserNotificationPreferences operation.
     * @callback module:api/NotificationsApi~setUserNotificationPreferencesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserNotificationPreferences} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set notification preferences for a user
     * Sets notification preferences for the user. Repeated calls overwrite existing preferences rather than returning 409. The userId in the path is authoritative; any userId in the body is ignored. 
     * @param {String} userId The unique identifier of the user
     * @param {module:model/UserNotificationPreferences} userNotificationPreferences 
     * @param {module:api/NotificationsApi~setUserNotificationPreferencesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserNotificationPreferences}
     */
    setUserNotificationPreferences(userId, userNotificationPreferences, callback) {
      let postBody = userNotificationPreferences;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling setUserNotificationPreferences");
      }
      // verify the required parameter 'userNotificationPreferences' is set
      if (userNotificationPreferences === undefined || userNotificationPreferences === null) {
        throw new Error("Missing the required parameter 'userNotificationPreferences' when calling setUserNotificationPreferences");
      }

      let pathParams = {
        'userId': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UserNotificationPreferences;
      return this.apiClient.callApi(
        '/users/notifications/{userId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateUserNotificationPreferences operation.
     * @callback module:api/NotificationsApi~updateUserNotificationPreferencesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserNotificationPreferences} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Partially update notification preferences for a user
     * Partially updates notification preferences. Only supplied topics are affected. Within a topic, only supplied channels are changed; omitted channels default to false on first creation (upsert). Returns the full updated preferences after the patch is applied. 
     * @param {String} userId The unique identifier of the user
     * @param {module:model/UserNotificationPreferencesPatch} userNotificationPreferencesPatch 
     * @param {module:api/NotificationsApi~updateUserNotificationPreferencesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserNotificationPreferences}
     */
    updateUserNotificationPreferences(userId, userNotificationPreferencesPatch, callback) {
      let postBody = userNotificationPreferencesPatch;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling updateUserNotificationPreferences");
      }
      // verify the required parameter 'userNotificationPreferencesPatch' is set
      if (userNotificationPreferencesPatch === undefined || userNotificationPreferencesPatch === null) {
        throw new Error("Missing the required parameter 'userNotificationPreferencesPatch' when calling updateUserNotificationPreferences");
      }

      let pathParams = {
        'userId': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UserNotificationPreferences;
      return this.apiClient.callApi(
        '/users/notifications/{userId}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
